<nz-modal
  [(nzVisible)]="isVisible"
  nzTitle="Corporate Details"
  [nzFooter]="null"
  [nzWidth]="900"
  (nzOnCancel)="modal.destroy()"
>
  <div class="details-modal-body" *nzModalContent>
    <div class="sidebar">
      <div class="flex-col-12">
        <nz-avatar nzSrc="assets/icons/corporate.svg"></nz-avatar>
        <div>
          <div class="name-line">
            {{ bodycorp.companyDetails?.name || '-' }}
          </div>
          <div class="email-line">
            BIN {{ bodycorp.companyDetails?.registrationNumber || '-' }}
          </div>
        </div>
      </div>

      <nz-divider class="divider-tight"/>

      <div>
        <p class="email-line">Roles</p>
        <div class="roles-wrap" *ngIf="!isPayer && !isRecipient">
          <div *ngFor="let role of getFilteredJobTitlesBodyCorporated(bodycorp)" class="role-item">
            <span class="role-badge">
              {{ mapRoleToText(role) }}
            </span>
          </div>
        </div>
        <div class="roles-wrap" *ngIf="isPayer || isRecipient">
          <div class="role-item">
            <span class="role-badge" *ngIf="isPayer">
              {{ 'Payer' }}
            </span>
            <span class="role-badge" *ngIf="isRecipient">
              {{ 'Recipient' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="details-content">
      <nz-tabset>
        <nz-tab nzTitle="General">
          <div class="sections-wrap">
            <!-- Company Details -->
            <div>
              <div class="section-title">Company Details</div>
              <div class="section-box">
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Company name</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.companyDetails?.name || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Registration Number / BIN</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.companyDetails?.registrationNumber || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Date of registration</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ (bodycorp.companyDetails?.registrationDate | date:'dd.MM.yyyy') || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Tax registration number in the country of incorporation</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.companyDetails?.taxNumber || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Type of activity</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.companyDetails?.typeOfActivity || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed" *ngIf="bodycorp.companyDetails?.legalForm">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Organisational legal form</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.companyDetails?.legalForm || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed" *ngIf="bodycorp.companyDetails?.licenseRegulatorName">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Name of a regulator issued a licence</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.companyDetails?.licenseRegulatorName || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed" *ngIf="bodycorp.companyDetails?.licenseNumber">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Licence number</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.companyDetails?.licenseNumber || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row" *ngIf="bodycorp.companyDetails?.licenseDate">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Date of licence issuance</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ (bodycorp.companyDetails?.licenseDate | date:'yyyy-MM-dd') || '-' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Address Details -->
            <div class="mb-4">
              <div class="section-title">Address Details</div>
              <div class="section-box">
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Place of incorporation</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.address?.country?.name || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Postal code</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.address?.postalCode || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>City</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.address?.city || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Street</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.address?.street || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Building number</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.address?.buildingNumber || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Office/Room number</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.address?.officeRoomNumber || '-' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contact Details -->
            <div class="mb-2" *ngIf="bodycorp.contactPerson">
              <div class="section-title">Contact Details</div>
              <div class="section-box">
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Email</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.contactPerson?.email || '-' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Contact number</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ bodycorp.contactPerson?.phoneNumber || '-' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Qualified Recipient -->
            <div class="mb-2" *ngIf="isQualifiedRecipient()">
              <div class="section-title">Qualified Recipient is:</div>
              <div *ngIf="bodycorp.qualifiedRecipient?.length; else noQualified" class="qr-box">
                <ng-container *ngFor="let line of qualifiedRecipientLines">
                  <div class="qr-line">{{ line }}</div>
                </ng-container>
              </div>
              <ng-template #noQualified>
                <div class="qr-box">
                  <div class="qr-line">—</div>
                </div>
              </ng-template>
            </div>
          </div>
        </nz-tab>
        <nz-tab nzTitle="Documents">
          <div class="document-list">
            <div *ngIf="certificates.length">
              <div class="document-group-title">
                <span>Certificate of Incorporation:</span>
              </div>
              <div class="document-item" *ngFor="let certificate of certificates">
                <div class="document-info">
                  <i nz-icon [nzType]="'paper-clip'" class="document-icon"></i>
                  <a class="document-link" (click)="previewFile(certificate)">{{ certificate.fileName }}</a>
                </div>
                <div>
                  <span class="document-date">{{ certificate.createdAt| date:'dd.MM.yyyy' }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="worldCheckDocuments.length">
              <div class="document-group-title">
                <span>World-Check:</span>
              </div>
              <div class="document-item" *ngFor="let worldCheckDoc of worldCheckDocuments">
                <div class="document-info">
                  <i nz-icon [nzType]="'paper-clip'" class="document-icon"></i>
                  <a class="document-link" (click)="previewFile(worldCheckDoc)">{{ worldCheckDoc.fileName }}</a>
                </div>
                <div>
                  <span class="document-date">{{ worldCheckDoc.createdAt| date:'dd.MM.yyyy' }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="kybOrganizationCheck">
              <div class="document-group-title">
                <span>KYB Organization Check:</span>
              </div>
              <div class="document-item">
                <div class="document-info">
                  <i nz-icon [nzType]="'paper-clip'" class="document-icon"></i>
                  <a class="document-link" (click)="previewKYBFile(kybOrganizationCheck)">{{ kybOrganizationCheck?.fileName }}</a>
                </div>
                <div *ngIf="kybOrganizationCheck?.createdAt">
                  <span class="document-date">{{ kybOrganizationCheck?.createdAt | date:'dd.MM.yyyy'}}</span>
                </div>
              </div>
            </div>
          </div>
        </nz-tab>
      </nz-tabset>
    </div>
  </div>
</nz-modal>
